import componentModule from './component';
import componentTypeModule from './componentType';
import measureTypeModule from './measureType';
import recipeModule from './recipe';
import productionOrderModule from './productionOrder';
import warehouseModule from './warehouse';
import stationTypeModule from './stationType';
import routeModule from './route';
import stationModule from './station';
import wipModule from './wip';
import stepExecutionModule from './stepExecution';
import inventoryModule from './inventory';
import identityModule from './identity';
import userModule from './user';
import instance from './instance';
import identityInstance from './identityInstance';

export default {
  component: componentModule(instance),
  componentType: componentTypeModule(instance),
  measureType: measureTypeModule(instance),
  recipe: recipeModule(instance),
  productionOrder: productionOrderModule(instance),
  warehouse: warehouseModule(instance),
  stationType: stationTypeModule(instance),
  route: routeModule(instance),
  station: stationModule(instance),
  wip: wipModule(instance),
  stepExecution: stepExecutionModule(instance),
  inventory: inventoryModule(instance),
  identity: identityModule(identityInstance),
  user: userModule(instance)
};
